<style lang="stylus">
    .fileview-share-container
        display flex
        flex 1
        flex-direction column
</style>

<template>
    <div class="fileview-share-container" @click="clear()" v-click-outside="clear">
        <RightMenu
            v-if="contextmenuBoxShow"
            :style="{ top: top + 'px', left: left + 'px' }"
            :menuList="menuList"
            @handleClicks="handleClick($event)"
        />

        <Searchback v-if="searchMode" :str="lastSearch" :num="searchList.length" @searchBack="searchBack" />

        <div v-if="layoutMode == 'list' && !searchMode && !noDataStatus" class="fileview-list-header fileview-share-list-header">
            <div class="file-name" @click="clickOrder('name')">
                <span>{{ $t("name") }}</span>
                <div class="icon-con">
                    <iconSymbol
                        :class="{ 'active-icon': orderName == 'name' && rotate == 180 }"
                        style="transform: rotate(180deg)"
                        :name="'pcview-fileUpIcon'"
                    ></iconSymbol>
                    <iconSymbol :class="{ 'active-icon': orderName == 'name' && rotate == 0 }" :name="'pcview-fileUpIcon'"></iconSymbol>
                </div>
            </div>
            <div class="file-time" @click="clickOrder('time')">
                <span>{{ $t("time") }}</span>
                <div class="icon-con">
                    <iconSymbol
                        :class="{ 'active-icon': orderName == 'time' && rotate == 180 }"
                        style="transform: rotate(180deg)"
                        :name="'pcview-fileUpIcon'"
                    ></iconSymbol>
                    <iconSymbol :class="{ 'active-icon': orderName == 'time' && rotate == 0 }" :name="'pcview-fileUpIcon'"></iconSymbol>
                </div>
            </div>
            <div class="file-size">
                <span>{{ $t("times") }}</span>
            </div>
        </div>
        <div class="fileview-scroll" @scroll="clear" @click="clearFile" ref="filesScroll">
            <span class="emptyCloud limit-position" v-cloak v-if="emptyStatus">
                <img src="@/home/assets/img/null-icon/default-null.svg" alt="" />
                <span>{{ $t("notTem") }}</span>
            </span>
            <template v-if="layoutMode == 'grid'">
                <div class="files-box" ref="filesBoxList">
                    <gridFile
                        v-for="(item, index) in searchMode ? searchList : filesList"
                        :key="index"
                        :type="'share'"
                        :mode="searchMode ? 'search' : 'files'"
                        :copyLink="copyLink"
                        :cancelShare="cancelShare"
                        :index="index"
                        :file="item"
                        :searchKey="searchValue"
                    />
                </div>
            </template>
            <template v-if="layoutMode == 'list'">
                <div class="list-cons">
                    <div class="files-box-list" ref="filesBoxList">
                        <listFile
                            v-for="(item, index) in searchMode ? searchList : filesList"
                            :key="index"
                            :type="'share'"
                            :mode="searchMode ? 'search' : 'files'"
                            :index="index"
                            :file="item"
                            :searchKey="searchValue"
                        />
                    </div>
                </div>
            </template>
        </div>
        <Modal v-model="showShareCode" width="250" :title="$t('passCode')">
            <p style="text-align: center">{{ currentPasscode }}</p>
            <div slot="footer">
                <Button type="primary" size="large" long @click="toCopyCode">{{ $t("copyCode") }}</Button>
            </div>
        </Modal>
    </div>
</template>

<script lang="ts">
    import naturalsort from "javascript-natural-sort";

    naturalsort.insensitive = true;
    import { Component, Prop, Vue, Mixins, Watch } from "vue-property-decorator";
    import fileItem from "../fileItem";
    import gridFile from "./gridFile.vue";
    import listFile from "./listFile.vue";
    import RightMenu from "../RightMenu.vue";
    import Searchback from "./parts/searchback.vue";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            fileItem,
            gridFile,
            listFile,
            RightMenu,
            Searchback,
        },
    })
    export default class Share extends Mixins(fileItem) {
        //生命周期
        filesList = [];
        searchMode = false;
        searchList = [];
        searchValue = "";

        get emptyStatus() {
            return this.userInfo && this.showNoShareTips && this.filesList && this.filesList.length == 0;
        }
        get noDataStatus() {
            return this.filesList.length == 0;
        }
        get menuList() {
            let list = [
                { label: this.$t("copy") },
                { label: this.$t("cancel") },
                {
                    label: this.$t("showCode"),
                    hide: this.selFiles.length === 1 && this.selFiles[0].code,
                },
            ];
            return list.filter((i) => (i.hasOwnProperty("hide") ? i.hide : true));
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }

        get layoutMode() {
            return this.$store.state.layoutMode;
        }
        set layoutMode(v) {
            this.$store.commit("setState", {
                type: "layoutMode",
                data: v,
            });
        }
        get top() {
            return this.$store.state.layoutTop;
        }
        set top(v) {
            this.$store.commit("setState", {
                type: "layoutTop",
                data: v,
            });
        }
        get left() {
            return this.$store.state.layoutLeft;
        }
        set left(v) {
            this.$store.commit("setState", {
                type: "layoutLeft",
                data: v,
            });
        }
        get contextmenuBoxShow() {
            return this.$store.state.fileContextShow;
        }

        set contextmenuBoxShow(v) {
            this.$store.commit("setState", {
                type: "fileContextShow",
                data: v,
            });
        }
        get selectFilesIndex() {
            return this.$store.state.selectFilesIndex;
        }
        set selectFilesIndex(v) {
            this.$store.commit("setState", {
                type: "selectFilesIndex",
                data: v,
            });
        }

        shareLink = "";
        shareModel = false;
        htmlValue = "";
        showNoShareTips = false;

        get showShareCode() {
            return this.$store.state.showShareCode;
        }
        set showShareCode(v) {
            this.$store.commit("setState", {
                type: "showShareCode",
                data: v,
            });
        }
        get currentPasscode() {
            return this.$store.state.shareLinkCode;
        }
        set currentPasscode(v) {
            this.$store.commit("setState", {
                type: "shareLinkCode",
                data: v,
            });
        }
        rotate = localStorage.getItem("max_order") || 0;
        orderName = localStorage.getItem("max_sort") || "time";

        get selFiles() {
            let list = this.filesList;
            if (this.searchValue) {
                list = this.searchList;
            }
            return list.filter((_, i) => {
                return this.selectFilesIndex.includes(i);
            });
        }

        handleClick(index) {
            let clickEvents = new Map([
                [
                    0,
                    () => {
                        this.copyLink();
                    },
                ],
                [
                    1,
                    () => {
                        this.cancelShare();
                    },
                ],
                [
                    2,
                    () => {
                        this.toShowShareCode();
                    },
                ],
            ]);
            const onClicks = clickEvents.get(index);
            onClicks && onClicks();
        }

        clickOrder(name) {
            let change = name !== this.orderName;
            this.setOrder(name);
            if (!change) {
                this.order();
            }
        }

        setOrder(name) {
            this.orderName = name;
            if (name === "time") {
                if (this.rotate == 180) {
                    this.filesList = this.filesList.sort((a, b) => new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime());
                } else {
                    this.filesList = this.filesList.sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime());
                }
            } else if (name === "times") {
                if (this.rotate == 180) {
                    this.filesList = this.filesList.sort((a, b) => a.pv - b.pv);
                } else {
                    this.filesList = this.filesList.sort((a, b) => b.pv - a.pv);
                }
            } else if (name === "name") {
                if (this.rotate == 0) {
                    this.filesList = this.filesList.sort((a, b) => naturalsort(a.title, b.title));
                } else {
                    this.filesList = this.filesList.sort((a, b) => naturalsort(b.title, a.title));
                }
            } else {
                this.orderName = "time";
                if (this.rotate == 180) {
                    this.filesList = this.filesList.sort((a, b) => new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime());
                } else {
                    this.filesList = this.filesList.sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime());
                }
            }
            localStorage.setItem("max_sort", this.orderName);
        }
        searchBack() {
            this.searchMode = false;
            this.searchValue = "";
            this.getShareList();
        }
        order() {
            if (this.rotate == 0) {
                this.rotate = 180;
                if (this.orderName == "name") {
                    this.filesList = this.filesList.sort((a, b) => naturalsort(b.title, a.title));
                } else if (this.orderName == "time") {
                    this.filesList = this.filesList.sort((a, b) => new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime());
                } else if (this.orderName == "times") {
                    this.filesList = this.filesList.sort((a, b) => a.pv - b.pv);
                }
            } else {
                this.rotate = 0;
                if (this.orderName == "name") {
                    this.filesList = this.filesList.sort((a, b) => naturalsort(a.title, b.title));
                } else if (this.orderName == "time") {
                    this.filesList = this.filesList.sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime());
                } else if (this.orderName == "times") {
                    this.filesList = this.filesList.sort((a, b) => b.pv - a.pv);
                }
            }
            localStorage.setItem("max_order", this.rotate.toString());
        }
        clearFile() {
            this.selectFilesIndex = [];
        }

        enter(e) {
            if (e.keyCode == 13) {
                this.search();
            }
        }
        lastSearch = "";
        search() {
            if (this.searchValue) {
                this.lastSearch = this.searchValue;
                this.$track("share", "search");
                this.searchMode = true;
                this.searchList = [];
                this.$store.commit("setState", { data: true, type: "showLoading" });
                this.searchValue = this.searchValue.trim();
                this.searchList = this.filesList.filter((item) => {
                    if (item.title.toLowerCase().includes(this.searchValue.toLowerCase())) {
                        let filePath = item.obj.match(/[^\/]+\/[^\/]+\/(.+)/) && item.obj.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
                        filePath = filePath.split("/");
                        let name = filePath.pop();
                        filePath = filePath.length ? this.$t("personal") + ">" + filePath.join(">") : this.$t("personal");
                        item.filePath = filePath;
                        return true;
                    }
                    return false;
                });
                if (this.searchList.length == 0) {
                    (<any>this).$edMessage.error(this.$t("notFind"));
                }
                this.$store.commit("setState", { data: false, type: "showLoading" });
            } else {
                this.searchMode = false;
            }
        }
        setLayout() {
            this.$track("share", "toggle layout");
            this.$store.commit("changeLayout");
            this.clearFile();
        }

        clear() {
            this.contextmenuBoxShow = false;
        }

        getShareList() {
            this.$store.commit("setState", { data: true, type: "showLoading" });
            this.$store
                .dispatch("getShareList")
                .then((res) => {
                    this.filesList = res.data;
                    this.setOrder(this.orderName);
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    if (this.filesList.length == 0) {
                        this.showNoShareTips = true;
                        // (<any>this).$edMessage.success(this.$t('notTem'))
                    }
                })
                .catch((err) => {
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                });
        }

        loadErr(e) {
            let lang = this.lang == "zh" ? "zh" : "en";
            e.target.src = require(`@/home/assets/img/files/default-files-${lang}.svg`);
        }

        contextmenu(e, files, index) {}

        toShowShareCode() {
            this.$track("share", "check password");
            this.currentPasscode = this.selFiles[0].code;
            this.showShareCode = true;
        }

        copyLink(index = -1) {
            if (index != -1) {
                this.selectFile(index);
            }
            this.$track("share", "copy link");
            this.shareLink = this.selFiles[0].domain + this.selFiles[0].uuid;
            let input = document.createElement("input");
            input.value = this.selFiles[0].domain + this.selFiles[0].uuid;
            document.body.appendChild(input);
            input.select();
            (<any>this).$edMessage.success(this.$t("copyTip"));
            document.execCommand("copy");
            document.body.removeChild(input);
        }
        toCopyCode() {
            let input = document.createElement("input");
            input.value = this.currentPasscode;
            document.body.appendChild(input);
            input.select();
            (<any>this).$edMessage.success(this.$t("copyCodeTip"));
            document.execCommand("copy");
            document.body.removeChild(input);
            this.showShareCode = false;
            this.currentPasscode = "";
        }

        cancelShare(index = -1) {
            if (index != -1) {
                this.selectFile(index);
            }
            (<any>this).$Modal.confirm({
                title: this.$t("cancel"),
                content: this.$t("isCancel"),
                cancelText: this.$t("cancelText"),
                okText: this.$t("okText"),
                onOk: () => {
                    this.$track("share", "cancel link");
                    this.$store.commit("setState", { data: true, type: "showLoading" });
                    this.$store
                        .dispatch("cancelShare", { fileId: this.selFiles[0].id })
                        .then((res) => {
                            let list = this.searchValue ? this.searchList : this.filesList;
                            Vue.delete(list, this.selectFilesIndex);
                            (<any>this).$edMessage.success(this.$t("cancelSucc"));
                            if (!list.length) {
                                this.showNoShareTips = true;
                            }
                            this.clearFile();
                            this.$store.commit("setState", { data: false, type: "showLoading" });
                        })
                        .catch((err) => {
                            this.$store.commit("setState", { data: false, type: "showLoading" });
                        });
                },
                onCancel: () => {},
            });
        }

        openFiles(file) {
            let shareHtml = `<iframe frameborder="no" border="0" marginwidth="0" marginheight="0" width=800 height=800 src="${window["GLOBAL"].PUBLIC_OSS_HOST}${file.url}main.svg"></iframe>`;
            this.$store.commit("setState", { type: "shareLink", data: file.domain + file.uuid });
            this.$store.commit("setState", { type: "shareLinkCode", data: file.code });
            this.$store.commit("setState", { type: "shareHTML", data: shareHtml });
            this.$store.commit("setState", {
                type: "shareData",
                data: {
                    title: file.title,
                    imgUrl: "",
                },
            });
            this.$store.commit("setState", { type: "shareState", data: true });
        }
        mounted() {
            if (!["name", "time", "times"].includes(this.orderName)) {
                this.orderName = "time";
            }
            this.$bus.$on("refreshEv", () => {
                this.getShareList();
            });
            if (this.userInfo) {
                if (!this.params.islogin) {
                    return;
                }
                this.getShareList();
            } else {
                this.$bus.$on("loginSucc-share", () => {
                    this.getShareList();
                });
            }
        }
        beforeDestroy() {
            this.selectFilesIndex = [];
            this.contextmenuBoxShow = false;
            this.currentPasscode = "";
            this.showShareCode = false;
            this.$bus.$off("refreshEv");
            this.$bus.$off("loginSucc-share");
        }
    }
</script>
<i18n>
{
  "zh": {
    "switchView": "切换视图",
    "title": "我的分享",
    "shareToMe": "分享给我",
    "search": "搜索",
    "allFiles": "所有分享",
    "name": "文件名",
    "time": "时间",
    "times": "浏览次数",
    "grid": "网格视图",
    "list": "列表视图",
    "copy": "复制链接",
    "showCode": "显示密码",
    "passCode": "密码",
    "copyCode": "复制密码",
    "use": "在HTML中使用：",
    "cancel": "取消分享",
    "cancelText": "取消",
    "okText": "确定",
    "share": "已分享",
    "notFind": "没有找到相关分享文件",
    "copyTip": "链接已复制到剪贴板",
    "copyCodeTip": "密码已复制到剪切板",
    "isCancel": "确定取消分享？",
    "cancelSucc": "取消分享成功",
    "personal": "个人云",
    "notTem": "分享是件快乐的事情，快来分享您的第一个作品吧。"
  },
  "en": {
    "switchView": "Switch View",
    "title": "Share",
    "shareToMe": "Shared with me",
    "search": "Search File",
    "allFiles": "All shared Files",
    "name": "Name",
    "time": "Time",
    "times": "View count",
    "grid": "Grid View",
    "list": "List View",
    "copy": "Copy Link",
    "showCode": "Show Password",
    "passCode": "Password",
    "copyCode": "Copy Password",
    "use": "Use in Html：",
    "cancel": "Stop Sharing",
    "cancelText": "No, I will keep it",
    "okText": "Yes",
    "share": "Shared Successfully",
    "notFind": "No related file found",
    "copyTip": "This link has been copied to the clipboard.",
    "copyCodeTip": "Password Copied Successfully",
    "isCancel": "Are you sure you want to permanently stop sharing this file?",
    "cancelSucc": "Stop Sharing Successfully",
    "personal": "Personal",
    "notTem": "The files you share with others will appear here. You can change the file settings at any time."
  },
  "fr": {
    "switchView": "Changer de vue",
    "title": "Ma part",
    "shareToMe": "Partage avec moi",
    "search": "Chercher",
    "allFiles": "Tous partagent",
    "name": "Nom",
    "time": "Temps",
    "times": "Nombre de vues",
    "grid": "Vue grille",
    "list": "Vue liste",
    "copy": "Copier le lien",
    "showCode": "Afficher le mot de passe",
    "passCode": "Mot de passe",
    "copyCode": "Copier le mot de passe",
    "use": "Utilisation en HTML:",
    "cancel": "Annuler le partage",
    "cancelText": "Annuler",
    "share": "Partagé",
    "notFind": "Aucun fichier partagé associé trouvé",
    "copyTip": "Le lien a été copié dans le presse-papiers!",
    "copyCodeTip": "Le mot de passe a été copié dans le presse-papiers",
    "isCancel": "Voulez-vous vraiment annuler le partage?",
    "cancelSucc": "Annuler le partage réussi",
    "personal": "Cloud personnel",
    "notTem": "Aucun fichier partagé pour le moment"
  },
  "de": {
    "switchView": "Ansicht wechseln",
    "title": "Mein Share",
    "shareToMe": "Teile mit mir",
    "search": "Suchen",
    "allFiles": "Alle Share",
    "name": "Name",
    "time": "Zeit",
    "times": "Anzahl anzeigen",
    "grid": "Rasteransicht",
    "list": "Listenansicht",
    "copy": "Link kopieren",
    "showCode": "Passwort anzeigen",
    "passCode": "Passwort",
    "copyCode": "Passwort kopieren",
    "use": "Verwendung in HTML:",
    "cancel": "Teilen abgesagt",
    "cancelText": "Abbrechen",
    "share": "Erfolgreich geteilt",
    "notFind": "Keine verwandte Datei gefunden",
    "copyTip": "Dieser Link wurde in die Zwischenablage kopiert!",
    "copyCodeTip": "Passwort erfolgreich kopiert",
    "isCancel": "Bist du sicher, dass du aufhörst zu teilen?",
    "cancelSucc": "Teilen erfolgreich beendet",
    "personal": "Persönlicher Cloud",
    "notTem": "Noch keine geteilte Datei"
  },
  "jp": {
    "switchView": "ビューを切り替える",
    "title": "共有",
    "shareToMe": "共有させてください",
    "search": "検索",
    "allFiles": "すべての共有",
    "name": "名前",
    "time": "時間",
    "times": "閲覧数",
    "grid": "グリッドビュー",
    "list": "リストビュー",
    "copy": "リンクをコピー",
    "showCode": "パスワードを表示",
    "passCode": "パスワード",
    "copyCode": "パスワードをコピー",
    "use": "HTMLで使用：",
    "cancel": "キャンセル",
    "cancelText": "キャンセル",
    "share": "共有しました",
    "notFind": "関連する共有ファイルが見つかりません",
    "copyTip": "リンクがクリップボードにコピーされました！",
    "copyCodeTip": "パスワードがクリップボードにコピーされました",
    "isCancel": "共有をキャンセルしますか",
    "cancelSucc": "共有をキャンセルしました",
    "personal": "個人クラウド",
    "notTem": "まだ共有されているファイルはありません"
  },
  "es": {
    "switchView": "Cambiar vista",
    "title": "Compartir",
    "shareToMe": "Comparte conmigo",
    "search": "Buscar archivo",
    "allFiles": "Todos los archivos compartidos",
    "name": "Nombre",
    "time": "Tiempo",
    "times": "Conteo de visitas",
    "grid": "Vista de cuadrícula",
    "list": "Vista de la lista",
    "copy": "Copiar link",
    "showCode": "Mostrar contraseña",
    "passCode": "Contraseña",
    "copyCode": "Copiar contraseña",
    "use": "Usar en HTML",
    "cancel": "Compartir cancelado",
    "cancelText": "Cancelar",
    "share": "Compartido exitosamente",
    "notFind": "No se encontró ningún archivo relacionado",
    "copyTip": "Este enlace ha sido copiado al portapapeles.",
    "copyCodeTip": "Contraseña copiada exitosamente",
    "isCancel": "¿Estás seguro de dejar de compartir?",
    "cancelSucc": "¿Estás seguro de dejar de compartir?",
    "personal": "Nube Personal",
    "notTem": "Los archivos que comparte con otros aparecerán aquí. Puede cambiar la configuración del archivo en cualquier momento."
  },
  "pt": {
    "switchView": "Trocar Visualização",
    "title": "Minha parte",
    "shareToMe": "Compartilhe comigo",
    "search": "Pesquisar Ficheiro",
    "allFiles": "Todos os Ficheiros partilhados",
    "name": "Nome",
    "time": "Hora",
    "times": "Visualizar contagem",
    "grid": "Visualização em Grelha",
    "list": "Visualização em Lista",
    "copy": "Copiar Ligação",
    "showCode": "Mostrar Password",
    "passCode": "Password",
    "copyCode": "Copiar Password",
    "use": "Usar em Html：",
    "cancel": "Partilha Cancelada",
    "cancelText": "Cancelar",
    "share": "Partilhado com Sucesso",
    "notFind": "Não encontrado ficheiro relacionado",
    "copyTip": "Esta ligação foi copiada para a área de transferência.",
    "copyCodeTip": "Password Copiada com Sucesso",
    "isCancel": "Tem a certeza que pretende parar a partilha?",
    "cancelSucc": "Partilha Parada com Sucesso",
    "personal": "Pessoal",
    "notTem": "Os ficheiros partilhados com outros irão aparecer aqui. Pode alterar as configurações do ficheiro a qualquer momento."
  },
  "it": {
    "switchView": "Cambia Vista",
    "title": "Condividi",
    "shareToMe": "Condividi con me",
    "search": "Cerca File",
    "allFiles": "Tutti i File Condivisi",
    "name": "Nome",
    "time": "Ora",
    "times": "Numero Visualizzazioni",
    "grid": "Vista a Griglia",
    "list": "Vista a Elenco",
    "copy": "Copia Collegamento",
    "showCode": "Mostra Password",
    "passCode": "Password",
    "copyCode": "Copia Password",
    "use": "Usa in HTML：",
    "cancel": "Condivisione Annullata",
    "cancelText": "Annulla",
    "share": "Condivisione Avvenuta con Successo",
    "notFind": "Nessun file trovato.",
    "copyTip": "Il collegamento è stato copiato negli appunti.",
    "copyCodeTip": "Password Copiata con Successo",
    "isCancel": "Confermi di voler annullare la condivisione?",
    "cancelSucc": "Annullamento della Condivisione Avvenuto con Successo",
    "personal": "Personali",
    "notTem": "Quest'area comprende tutti i file che hai condiviso con altri. Puoi modificare le impostazioni di ciascun file in qualsiasi momento."
  },
  "tw": {
    "switchView": "切換視圖",
    "title": "分享給我",
    "shareToMe": "分享给我",
    "search": "搜尋",
    "allFiles": "所有分享",
    "name": "檔案名",
    "time": "時間",
    "times": "瀏覽次數",
    "grid": "網格視圖",
    "list": "列表視圖",
    "copy": "複製連結",
    "showCode": "顯示密碼",
    "passCode": "密碼",
    "copyCode": "複製密碼",
    "use": "在HTML中使用：",
    "cancel": "取消分享",
    "cancelText": "取消",
    "share": "已分享",
    "notFind": "沒有找到相關分享檔案",
    "copyTip": "連結已複製到剪下板",
    "copyCodeTip": "密碼已複製到剪下板",
    "isCancel": "確定取消分享？",
    "cancelSucc": "取消分享成功",
    "personal": "個人雲端硬碟",
    "notTem": "分享是件快樂的事情，快來分享您的第一個作品吧。"
  },
  "kr": {
    "switchView": "보기 전환",
    "title": "사용자가 공유한 파일",
    "shareToMe": "사용자한테 공유된 파일",
    "search": "찾기",
    "allFiles": "모든 공유 파일",
    "name": "파일 이름",
    "time": "시간",
    "times": "조회 횟수",
    "grid": "그리드보기",
    "list": "목록보기",
    "copy": "링크 복사",
    "showCode": "암호 표시",
    "passCode": "암호",
    "copyCode": "암호 복사",
    "use": "HTML에서 사용：",
    "cancel": "공유 취소",
    "cancelText": "취소",
    "share": "공유 완료",
    "notFind": "해당 공유 파일을 찾지 못했습니다.",
    "copyTip": "링크가 클립 보드에 복사되었습니다.",
    "copyCodeTip": "암호가 클립 보드에 복사되었습니다.",
    "isCancel": "공유 취소하시겠습니까？",
    "cancelSucc": "공유 취소 성공",
    "personal": "개인 클라우드",
    "notTem": "지식과 정보 공유는 늘 새로운 영감을 주죠! 당신의 작품을 글로벌 유저들과 공유해보아요~"
  },
  "id": {
    "switchView": "Ganti Tampilan",
    "title": "Bagikan",
    "shareToMe": "Bagikan dengan saya",
    "search": "Cari File",
    "allFiles": "Semua File yang dibagikan",
    "name": "Nama",
    "time": "Waktu",
    "times": "Lihat jumlah",
    "grid": "Tampilan Kisi",
    "list": "Tampilan Daftar",
    "copy": "Salin Tautan",
    "showCode": "Tampilkan Kata Sandi",
    "passCode": "Kata Sandi",
    "copyCode": "Salin Kata Sandi",
    "use": "Gunakan di Html :",
    "cancel": "Berhenti Berbagi",
    "cancelText": "Tidak, saya akan menyimpannya",
    "okText": "Ya",
    "share": "Berhasil Dibagikan",
    "notFind": "Tidak ada file terkait",
    "copyTip": "Tautan ini telah disalin ke papan klip.",
    "copyCodeTip": "Kata Sandi Berhasil Disalin",
    "isCancel": "Yakin ingin berhenti membagikan file ini secara permanen?",
    "cancelSucc": "Berhenti Berbagi Berhasil",
    "personal": "Personal",
    "notTem": "File yang Anda bagikan dengan orang lain akan muncul di sini. Anda dapat mengubah pengaturan file kapan saja."
  }
}
</i18n>
